import MuiLink, { type LinkProps } from "@mui/material/Link";

export type { LinkProps };

export function Link(props: LinkProps) {
  return <MuiLink {...props} />;
}
